// Route: '/game/:gameid/:qid'
import React, { useContext, useEffect, useState } from 'react';
import Nav from '../../components/Nav/Nav';
import { fileToDataUrl } from '../../utils/helpers';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { ImCross } from 'react-icons/im';
import { Main } from '../../styles';
import {
  AddImageContainer, AddImageContainerNoBorder,
  Image, QuestionContainer, QuestionIuputContainer,
  OptionContainer, MainContainer, AnswerContainer,
  CheckBoxContainer, AnswerOuterContainer, OptionInnerContainer,
  RadioContainer, AnswerFieldContainer, VideoContainer
} from './EditQuestionPage.styles';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextInput from '../../components/TextInput/TextInput';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { StoreContext } from '../../utils/store';
import { BiImageAdd } from 'react-icons/bi';

const EditQuestionPage = () => {
  const history = useHistory();
  const context = useContext(StoreContext);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;
  const { gameid, qid } = useParams();

  // materail ui styles
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 230,
      display: 'flex',
      flexDirection: 'column',
    }
  }));
  const classes = useStyles();

  // react icon styles
  const addImageIconStyles = {
    width: '200px',
    height: '200px',
    color: '#e9e9e9',
    cursor: 'pointer',
  };
  const removeButtonStyles = {
    backgroundColor: '#e9e9e9',
    padding: '5px',
    fontSize: '1.2em',
    borderRadius: '50%',
    cursor: 'pointer',
    position: 'absolute',
    right: '4px',
    top: '4px',
    minWidth: '0',
  };

  // question content states
  const [type, setType] = useState('Single');
  const [qString, setQString] = useState('');
  const [timeLimit, setTimeLimit] = useState('0');
  const [point, setPoint] = useState('0');
  const [numberOfAnswers, setNumberOfAnswers] = useState('2');
  const [answers, setAnswers] = useState([]);
  const [correctAnswers, setCorrectAnswers] = useState([true, false, false, false, false, false]);
  const [correctAnswer, setCorrectAnswer] = useState(0);
  const [mediaType, setMediaType] = useState('');
  const [quiz, setQuiz] = useState({});
  const [edited, setEdited] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [videoUrl, setVideoUrl] = useState('');

  // api call functions
  const updateQuestion = async () => {
    const question = {
      qString,
      type,
      timeLimit: parseInt(timeLimit, 10),
      point: parseInt(point, 10),
      answers,
      mediaType,
      correctAnswers,
      img: imageSrc,
      video: videoUrl,
    };
    console.log(question);
    const newQuestions = [...quiz.questions];
    newQuestions[qid] = question;
    const response = await api.makeAPIRequest(`admin/quiz/${gameid}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        questions: newQuestions,
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        setEdited(true);
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  const getQuiz = async () => {
    const response = await api.makeAPIRequest(`admin/quiz/${gameid}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        return json;
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  }

  // answers/correct answers state control functions
  const updateAnswers = (value, idx) => {
    const newAnswers = [...answers];
    newAnswers[idx] = value;
    setAnswers(newAnswers);
  }
  const updateCorrectAnswer = (e) => {
    setCorrectAnswer(parseInt(e.target.value, 10));
    const newCorrectAnswers = [...correctAnswers];
    for (let i = 0; i < numberOfAnswers; i++) {
      newCorrectAnswers[i] = false;
    }
    newCorrectAnswers[e.target.value] = true;
    setCorrectAnswers(newCorrectAnswers);
    console.log(correctAnswers);
    console.log(typeof correctAnswer);
  };

  const updateCorrectAnswers = (e, idx) => {
    const newCorrectAnswers = [...correctAnswers];
    newCorrectAnswers[idx] = e.target.checked;
    console.log('correct answers', newCorrectAnswers);
    setCorrectAnswers(newCorrectAnswers);
  };

  // image/video state control functions
  const updateImageSrc = async (e) => {
    const src = await fileToDataUrl(e.target.files[0]);
    console.log(e.target.files);
    setImageSrc(src);
  };
  const removeImage = () => {
    setImageSrc('')
  };
  const updateVideoUrl = (e) => {
    const newUrl = e.target.value.replace('watch?v=', 'embed/');
    setVideoUrl(newUrl);
  };

  // answers/correct answers state control triggers
  useEffect(async () => {
    const q = await getQuiz();
    const a = q.questions[qid].answers;
    const c = q.questions[qid].correctAnswers;
    console.log(c);
    const newAnswers = [];
    for (let i = 0; i < numberOfAnswers; i++) {
      newAnswers.push(a[i] || '');
    }
    setAnswers(newAnswers);
    const newCorrectAnswers = [];
    for (let i = 0; i < numberOfAnswers; i++) {
      newCorrectAnswers[i] = c[i] || false;
    }
    setCorrectAnswers(newCorrectAnswers);
  }, [numberOfAnswers]);

  // set up initial state
  useEffect(async () => {
    const q = await getQuiz();
    setQuiz(q);
    const qData = q.questions[qid];
    console.log(qData);
    setQString(qData.qString);
    setType(qData.type);
    setTimeLimit(qData.timeLimit ? qData.timeLimit.toString() : '');
    setPoint(qData.point.toString());
    setMediaType(qData.mediaType);
    setNumberOfAnswers(qData.answers.length);
    const newAnswers = [...answers];
    qData.answers.forEach((ans, idx) => { newAnswers[idx] = ans; });
    setAnswers(newAnswers);
    console.log(qData.correctAnswers);
    setCorrectAnswers(qData.correctAnswers);
    for (const idx in qData.correctAnswers) {
      if (qData.correctAnswers[idx]) {
        setCorrectAnswer(parseInt(idx, 10));
      }
    }
    setImageSrc(qData.img);
    setVideoUrl(qData.video);
  }, []);

  if (edited) {
    return <Redirect to={'/game/' + gameid} />
  }

  return (
    <>
      <section>
        <Nav
          visibilities={['false', 'false', 'false', 'true', 'true']}
          exit={() => history.push('/game/' + gameid)}
          confirm={updateQuestion}
        />
        <Main>
          <MainContainer>
            <QuestionContainer>
              <QuestionIuputContainer>
                <TextField
                  placeholder="Type your question"
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  value={qString}
                  onChange={e => setQString(e.target.value)}
                />
              </QuestionIuputContainer>
              {mediaType &&
                <>
                {mediaType === 'img'
                  ? <>
                    {imageSrc
                      ? <AddImageContainerNoBorder>
                          <Image src={imageSrc} alt={qString} />
                          <ImCross
                            style={removeButtonStyles}
                            onClick={removeImage}
                          />
                        </AddImageContainerNoBorder>
                      : <AddImageContainer>
                        <label htmlFor='add-image'>
                          <BiImageAdd style={addImageIconStyles} />
                        </label>
                        <input
                          type='file'
                          id='add-image'
                          file={imageSrc}
                          // value={imageSrc}
                          onChange={updateImageSrc}
                          hidden />
                      </AddImageContainer>
                    }
                  </>
                  : <AddImageContainerNoBorder>
                    <VideoContainer
                      src={videoUrl}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen>
                    </VideoContainer>
                  </AddImageContainerNoBorder>
                }
                </>
              }

              <AnswerFieldContainer>
                <FormControl component="fieldset" className={classes.formControl}>
                  <AnswerOuterContainer>
                    {answers.map((ans, idx) => (
                      <AnswerContainer key={idx}>
                        <div>
                          <TextInput
                            label={`Answer ${idx + 1}`}
                            value={ans}
                            onChange={e => updateAnswers(e.target.value, idx)}
                          />
                        </div>
                        { type === 'Multiple'
                          ? <CheckBoxContainer>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={correctAnswers[idx] || false}
                                  onChange={e => updateCorrectAnswers(e, idx)}
                                />}
                            />
                          </CheckBoxContainer>
                          : <RadioContainer>
                            <Radio
                              checked={correctAnswer === idx}
                              onChange={updateCorrectAnswer}
                              value={idx}
                              name="correct-answer-radio"
                            />
                          </RadioContainer>
                        }
                      </AnswerContainer>
                    ))}
                  </AnswerOuterContainer>

                </FormControl>
              </AnswerFieldContainer>
            </QuestionContainer>
            <OptionContainer>
              <OptionInnerContainer>
                <FormControl component="fieldset">
                  <FormLabel component='legend'>Media Type</FormLabel>
                  <RadioGroup aria-label='media type' name='media' value={mediaType} onChange={e => setMediaType(e.target.value)}>
                    <FormControlLabel value='img' control={<Radio />} label='Image' />
                    <FormControlLabel value='video' control={<Radio />} label='Video' />
                  </RadioGroup>
                </FormControl>
              </OptionInnerContainer>
              {mediaType === 'video' &&
                <OptionInnerContainer>
                  <TextInput
                    label='Youtube Video (copy the URL)'
                    value={videoUrl}
                    onChange={updateVideoUrl}
                  />
                </OptionInnerContainer>
              }
              <OptionInnerContainer>
                <TextInput
                  label='Time limit'
                  value={timeLimit}
                  onChange={e => setTimeLimit(e.target.value)}
                />
              </OptionInnerContainer>
              <OptionInnerContainer>
                <TextInput
                  label='Point'
                  value={point}
                  onChange={e => setPoint(e.target.value)}
                />
              </OptionInnerContainer>
              <OptionInnerContainer>
                <FormControl className={classes.formControl}>
                  <InputLabel id='type-select-label'>Question Type</InputLabel>
                  <Select
                    labelId='type-select-label'
                    id='type-select'
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <MenuItem value={'Multiple'}>Multiple choice</MenuItem>
                    <MenuItem value={'Single'}>Single choice</MenuItem>
                  </Select>
                </FormControl>
              </OptionInnerContainer>
              <OptionInnerContainer>
                <FormControl className={classes.formControl}>
                  <InputLabel id='answers-select-label'>Number of Answers</InputLabel>
                  <Select
                    labelId='answers-select-label'
                    id='answers-select'
                    value={numberOfAnswers}
                    onChange={(e) => setNumberOfAnswers(e.target.value)}
                  >
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                  </Select>
                </FormControl>
              </OptionInnerContainer>
            </OptionContainer>
          </MainContainer>
        </Main>
      </section>
    </>
  );
};

export default EditQuestionPage;
